var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',_vm._l((_vm.translations),function(translation,index){return _c("admin-translation-row",{key:translation.id,tag:"tr",attrs:{"initial-translation":translation,"index":index,"languages":_vm.languageList},on:{"deleteTranslation":_vm.deleteTranslation}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }